import { InputComponentProps } from "components/molecules/RenderPollQuestion/RenderPollQuestion";

export default function HeaderInput({ question }: InputComponentProps) {
  return (
    <p className="fw-600 fs-12 fw-130 text-grey-2 mb-2">{question?.question}</p>
  );
}
